import React, { useState, useEffect, useRef } from "react";
import { ddException } from '../utils/search.engine';
import { isRenu } from '../utils/ui.utils';
import { FacilityProcessingLabel } from './FacilityProcessingLabel';
import RDSCertified from './RDSCertified'; // RDSCertified is a component defined in App.js
import TagManager from "react-gtm-module"; // For analytics. Will need to verify its usage.


export const ContentSelector = ({ data, onChange, activeSection, t }) => {
  const lotHat = useRef(null);

  useEffect(() => {
    if (lotHat.current) {
      lotHat.current.focus();
    }
  }, []); // Equivalent to componentDidMount

  // --- Refactored Translate functions using props.t ---
  const spTranslate = (down_type, lotPrefix) => {
    const safeLotPrefix = lotPrefix || '';

    if (safeLotPrefix === '0225' || safeLotPrefix === '1021') {
      if (isRenu(down_type)) {
      return "RENU CIRCLE RECYCLED DOWN";
      }
    }

    if (isRenu(down_type)) {
      return t("species.renuBlend");
    }
    switch (down_type) {
      case "White Goose": return t("species.whiteGoose");
      case "Grey Goose": return t("species.greyGoose");
      case "White Duck": return t("species.whiteDuck");
      case "Muscovy White Duck": return t("species.muscovyWhiteDuck");
      case "Muscovy Grey Duck": return t("species.muscovyGreyDuck");
      case "Grey Duck": return t("species.greyDuck");
      default: return t("species.default");
    }
  };

  const locationID = (e) => {
    switch (e) {
      case "Hungary": return t("origin.hungary");
      case "Europe": return t("origin.europe");
      case "China": return t("origin.china");
      default: return t("origin.china");
    }
  };
  // --- End Refactored Translate functions ---


  // --- Ported handleChangee method ---
  const handleChangee = (e) => {
    let radios = document.querySelectorAll(".content-summary input");
    let checkboxes = document.querySelectorAll(".ac-input");
    let contentBox = document.querySelector(".content-face");

    onChange(e.target.dataset.value); // Corrected: pass only newSection

    document.querySelector("body").setAttribute("data-active", "");
    document.querySelector("body").dataset.active = e.target.dataset.value;

    //analytics (if TagManager is initialized in App.js)
    if (typeof TagManager !== 'undefined' && TagManager.instance) {
      TagManager.instance.dataLayer.push({
        event: "pageview",
        page: {
          url: window.location.pathname + window.location.search +"#"+e.target.dataset.value,
        },
      });
    }

    for (let y = 0; y < radios.length; y++) {
      radios[y].checked = false;
      if (e.target.dataset.value == radios[y].value) {
        radios[y].checked = true;
      }
    }

    for (let y = 0; y < checkboxes.length; y++) {
      checkboxes[y].parentNode.classList.remove("active");
      checkboxes[y].parentNode.classList.add("hide");
      checkboxes[y].checked = false;

      if (e.target.dataset.value == checkboxes[y].dataset.slug) {
        checkboxes[y].checked = true;
        contentBox.classList.add("active");
        checkboxes[y].parentNode.classList.remove("hide");
        checkboxes[y].parentNode.classList.add("active");
        checkboxes[y].focus();
      }
    }
  };
  // --- End Ported handleChangee method ---


  // --- Ported handleChange method ---
  const handleChange = (e) => {
    let radios = document.querySelectorAll(".content-summary input");
    let checkboxes = document.querySelectorAll(".ac-input");
    let contentBox = document.querySelector(".content-face");

    if (e != "CERTIFICATIONS" && e != "PROCESSING") {
      e.target.focus();

      onChange(e.target.value); // Corrected: pass only newSection

      document.querySelector("body").setAttribute("data-active", "");
      document.querySelector("body").dataset.active = e.target.value;

      //analytics (if TagManager is initialized in App.js)
      if (typeof TagManager !== 'undefined' && TagManager.instance) {
        TagManager.instance.dataLayer.push({
          event: "pageview",
          page: {
            url: window.location.pathname + window.location.search +"#"+e.target.value,
          },
        });
      }

      for (let y = 0; y < checkboxes.length; y++) {
        checkboxes[y].parentNode.classList.remove("active");
        checkboxes[y].parentNode.classList.add("hide");
        checkboxes[y].checked = false;

        if (e.target.value == checkboxes[y].dataset.slug) {
          checkboxes[y].checked = true;
          contentBox.classList.add("active");
          checkboxes[y].parentNode.classList.remove("hide");
          checkboxes[y].parentNode.classList.add("active");
        }
      }
    } else {
      onChange(e); // Corrected: pass only newSection

      document.querySelector("body").setAttribute("data-active", "");
      document.querySelector("body").dataset.active = e;

      //analytics (if TagManager is initialized in App.js)
      if (typeof TagManager !== 'undefined' && TagManager.instance) {
        TagManager.instance.dataLayer.push({
          event: "pageview",
          page: {
            url: window.location.pathname + window.location.search +"#"+e,
          },
        });
      }

      for (let y = 0; y < checkboxes.length; y++) {
        checkboxes[y].parentNode.classList.remove("active");
        checkboxes[y].parentNode.classList.add("hide");
        checkboxes[y].checked = false;

        if (e == checkboxes[y].dataset.slug) {
          checkboxes[y].checked = true;
          contentBox.classList.add("active");
          checkboxes[y].parentNode.classList.remove("hide");
          checkboxes[y].parentNode.classList.add("active");
          checkboxes[y].focus();
        }
      }
    }
  };
  // --- End Ported handleChange method ---

  let brandPrefix = data.prefix;
  let brandPrefixAlt = data.brandPrefixAlt;
  let linky;
  let brandNamePrint = data.brandName || "";
  let brandLogoPrint = false;

  // 1. Determine the Brand Name
  // If data.brandNameAlt is specifically a single space, we treat it as a valid "blank" override
  if (data.brandNameAlt === " ") {
    brandNamePrint = "";
  } else if (data.brandNameAlt && data.brandNameAlt.trim() !== "") {
    brandNamePrint = data.brandNameAlt;
  }

  // 2. Determine the Image Path
  linky = "//trackmydown.com/img/_brands/" + (brandPrefixAlt || brandPrefix) + ".svg";

  // 3. Determine if we should show a Logo or Text
  if (data.brandLogo) {
    if (data.brandNameAlt && (data.brandLogoAlt === undefined || data.brandLogoAlt === false)) {
      // If we have an Alt Name (exception) and no explicit Alt Logo "true" flag,
      // default to text to ensure the exception name is visible.
      brandLogoPrint = false;
    } else if (data.brandLogoAlt !== undefined) {
      brandLogoPrint = data.brandLogoAlt;
    } else {
      brandLogoPrint = true;
    }
  }

  const { originExceptionFlag, ddZero } = data;

  return (
    <div className="content-hat">
      <div className="content-title">
        {brandLogoPrint ? (
          data.brandLink != undefined ? (
            <a href={"//" + data.brandLink} target="_blank">
              <img src={linky} alt={brandNamePrint} />
            </a>
          ) : (
            <img src={linky} alt={brandNamePrint} />
          )
        ) : data.brandLink != undefined ? (
          <a href={"//" + data.brandLink}>
            <p>{brandNamePrint}</p>
          </a>
        ) : (
          <p>{brandNamePrint}</p>
        )}
      </div>
      <div className="content-summary">
        <form>          
          <input
            type="radio"
            id="lot"
            name="tmd"
            value="LOT"
            defaultChecked={activeSection === "LOT"} // Use activeSection for checked state
            onChange={handleChange}
            ref={lotHat}
          />
          <label htmlFor="lot">
            LOT N<sup>O</sup>{" "}
            {data.display_lotAlt != undefined
              ? data.display_lotAlt
              : data.display_lot}
          </label>            
          {!ddZero && (
            <>
              <input
                type="radio"
                id="fp"
                name="tmd"
                value="FP"
                checked={activeSection === "FP"}
                onChange={handleChange}
              />
              <label htmlFor="fp">                  
                {data.stated_fp}{" "}
                {t("fillPower")}{" "}
                {t("verifiedAt")}{" "}
                {data.verified_fp}{" "}
                {t("fpStandard")}
              </label>
            </>
          )}

          {data.chinaDomestic && (
            <>
              <input
                type="radio"
                id="fp2"
                name="tmd"
                value="FP2"
                data-value="FP2"
                checked={activeSection === "FP2"}
                onChange={handleChange}
              />
              <label htmlFor="fp2">
                {data.verified_fp_gb}{" "}
                {t("fpgbStandard")}
              </label>
            </>
          )}   
          <input
            type="radio"
            id="species"
            name="tmd"
            value="SPECIES"
            checked={activeSection === "SPECIES"} // Use activeSection for checked state
            onChange={handleChange}
          />
          <label htmlFor="species">
            {spTranslate(data.down_type, data.prefix)}
          </label>

          {isRenu(data.down_type) ||
          data.oFlag === true ? null : (
            <>
              <input
                type="radio"
                id="origin"
                name="tmd"
                value="ORIGIN"
                checked={activeSection === "ORIGIN"} // Use activeSection for checked state
                onChange={handleChange}
              />
              <label htmlFor="origin">
                {originExceptionFlag ? locationID("Hungary") : (data.origin && data.origin[0] ? locationID(data.origin[0]) : '')}{" "} 
              </label>
            </>
          )}

          <input
            type="radio"
            id="cleanliness"
            name="tmd"
            value="CLEANLINESS"
            checked={activeSection === "CLEANLINESS"} // Use activeSection for checked state
            onChange={handleChange}
          />
          <label htmlFor="cleanliness">
            {t("hypoallergenic")}
          </label>

          <input
            type="radio"
            id="content"
            name="tmd"
            value="CONTENT"
            checked={activeSection === "CONTENT"} // Use activeSection for checked state
            onChange={handleChange}
          />
          <label htmlFor="content">
            {data.down_cluster}%{" "}
            {t("clusterContent")}
          </label>

          {/* 🚀 BETA SIDEBAR FIX: Only render if treatment is a valid truthy value */}
          {data.normalizedTreatment && 
           data.normalizedTreatment !== "none" && 
           data.normalizedTreatment !== "false" && (
            <>
              <input
                className="tr-list"
                type="radio"
                id="treatment"
                name="tmd"
                value="TREATMENT"
                checked={activeSection === "TREATMENT"}
                onChange={handleChange}
              />
              <label htmlFor="treatment">
                {/* Ensures we display the string value correctly if it's an array or string */}
                {Array.isArray(data.normalizedTreatment) ? data.normalizedTreatment[0] : data.normalizedTreatment}
                {" "}
                {t("treatment.label")}
              </label>
            </>
          )}

          <FacilityProcessingLabel 
            facility={data.facility !== "" ? data.facility : "Los Angeles"}
            changeWord={handleChange}
            t={t}
          />

          <RDSCertified              
            isBrand={data.brand}
            isrds={!!data.rds}
            isrsd={!!data.rsd}
            treatment={data.treatment}
            isgrs={isRenu(data.down_type)}
            value="CERTIFICATIONS"
            checked={activeSection === "CERTIFICATIONS"}
            changeWord={handleChange}
            t={t}
          />

          <input
            type="radio"
            id="color-migration"
            name="tmd"
            value="CM"
            checked={activeSection === "CM"} // Use activeSection for checked state
            onChange={handleChange}
          />
          <label htmlFor="color-migration">
            {t("colorAndMigrationNotes")}
          </label>

          <input
            type="radio"
            id="sustainability"
            name="tmd"
            value="SUSTAINABILITY"
            checked={activeSection === "SUSTAINABILITY"} // Use activeSection for checked state
            onChange={handleChange}
          />
          <label htmlFor="sustainability">
            {t("environmentalImpact")}
          </label>

          <input
            type="radio"
            id="care"
            name="tmd"
            value="CARE"
            checked={activeSection === "CARE"} // Use activeSection for checked state
            onChange={handleChange}
          />
          <label htmlFor="care">
            {t("care.label")}
          </label>
        </form>

        <div
          isrds={!!data.rds ? "true" : "false"}
          isgrs={
            isRenu(data.down_type)
              ? true.toString()
              : false.toString()
          }
          onClick={handleChangee}
          data-value="CERTIFICATIONS"
          className={
            data.rds
              ? "cert-grid rds"
              : isRenu(data.down_type)
              ? "cert-grid grs"
              : "cert-grid"
          }
        >
          {data.rsd ? null : <div data-value="CERTIFICATIONS" className="rds"></div>}
          {isRenu(data.down_type) ? (
            <div data-value="CERTIFICATIONS" className="grs"></div>
          ) : null}
          <div data-value="CERTIFICATIONS" className="bluesign"></div>
          {data.aafa ? (
            <div value="CERTIFICATIONS" className="aafa"></div>
          ) : null}
          {(!data.treatment || data.treatment.length === 0 || !data.treatment[0]) ? (
            <div data-value="CERTIFICATIONS" className="oeko"></div>
          ) : null}            
        </div>
      </div>
    </div>
  );
};
